type Props = {
  description: string
}

export const GuestsVoicesContentItemDescription = ({
  description,
}: Props): JSX.Element => (
  <div className="text-[3.7vw] lg:text-[1.3vw] leading-[7.5vw] lg:leading-[2.5vw] text-[#333333]">
    {description}
  </div>
)
